export const RESET = 'EXSBPRICELIST_UPDATE_RESET'
export const SET_ERROR = 'EXSBPRICELIST_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBPRICELIST_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBPRICELIST_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBPRICELIST_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBPRICELIST_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBPRICELIST_UPDATE_UPDATE_RETRIEVED'
